import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PsfPromoteOrSharePageData } from './types';

const CHIP_IN_USD_FALLBACK = 3;

/** Smallest configured promotion amount for the viewer's country, or ~$3 converted when there are none. */
export function smallestChipInAmount(
	utilityContext: UtilityContext,
	viewerCurrency: { code: string; exchangeRate: number },
	amountChoices: readonly number[] | undefined,
): Pick<PsfPromoteOrSharePageData, 'chipInAmount' | 'chipInAmountLocalized' | 'chipInCurrencyCode'> {
	const { i18n } = utilityContext;
	const smallestAmountChoice = amountChoices?.length ? Math.min(...amountChoices) : undefined;
	const chipInAmount = smallestAmountChoice || Math.round(CHIP_IN_USD_FALLBACK * viewerCurrency.exchangeRate);
	return {
		chipInAmount,
		chipInAmountLocalized: i18n.localizeCurrency(chipInAmount, viewerCurrency.code),
		chipInCurrencyCode: viewerCurrency.code,
	};
}
